import React from 'react';

import { ICardProps } from './interface';

export const Card = ({
  data: { id, icon, gifttiername, title, description },
  theme,
}: ICardProps) => {
  const iconClass = `vitrine-template6__card--icon ${
    gifttiername || theme.replace(/"|\[|\]/g, '')
  }`;

  return (
    <div className="vitrine-template6__card" data-id={id}>
      {icon && (
        <span className={iconClass}>
          <img src={icon} alt={title} />
        </span>
      )}
      <span
        className="vitrine-template6__card--title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <span
        className="vitrine-template6__card--description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
